import { Text } from "Controls/TextControl";

/**
 * Control for hidden text input.
 * @since 4.0.0
 * @example 
 * ```JavaScript
 * // Access the instance of a HiddenText with ControlID 1337
 * // In script:
 * @@ctr:1337@@
 * 
 * // On page:
 * $dms(1337)
 * ```
 */
export class HiddenText extends Text {

    /**
     * @hidden
     */
    protected dmsControlClass: string = "dms-control-hiddentext";

    /**
     * @hidden
     */
    protected defaultEditorElement: string = "<input type='hidden' />";

    /**
     * Gets the display template for formatting in grid row.
     * @hidden
     */
    protected getDisplayTemplate(bindingField?: string): string {
        return `#= "" #`;
    }
}
